import { useAuth } from '../../auth';

/**
 * Prominent banner that displays authentication errors (e.g. Microsoft Entra ID redirect errors).
 * Only visible when there is an auth error and the user is not signed in.
 */
export function AuthErrorBanner() {
  const { error, clearError, user } = useAuth();

  if (!error || user) return null;

  return (
    <div
      className="bg-error-bg border-b border-error-border"
      role="alert"
      aria-live="assertive"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-start gap-3">
          {/* Error icon */}
          <svg
            className="w-5 h-5 text-error mt-0.5 shrink-0"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
              clipRule="evenodd"
            />
          </svg>

          {/* Error content */}
          <div className="flex-1 min-w-0">
            <h2 className="text-sm font-semibold text-error-text">
              Authentication Error
            </h2>
            <p className="mt-1 text-sm text-error-text whitespace-pre-line break-words">
              {error}
            </p>
          </div>

          {/* Dismiss button */}
          <button
            type="button"
            onClick={clearError}
            className="shrink-0 p-1 text-error-text hover:text-error rounded-component hover:bg-error/10 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-grey-100 focus-visible:outline-offset-0"
            aria-label="Dismiss error"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
